// Funciones
import { ROUTES } from '../../../../../const/routes';

/**
 * Assets de los botones
 * @param {*} scene
 */
export function cargaAssetsBotones(scene) {
  // Assets boton jugar
  scene.load.image(
    'botonJugar',
    ROUTES.rutaRuletaBotones + '/boton1JugarEstaticoResized.png'
  );
  scene.load.image(
    'botonJugarHover',
    ROUTES.rutaRuletaBotones + '/boton1JugarHoverResized.png'
  );
  scene.load.image(
    'botonJugarPressed',
    ROUTES.rutaRuletaBotones + '/boton1JugarPressedResized.png'
  );
  scene.load.image(
    'botonJugarDesactivado',
    ROUTES.rutaRuletaBotones + '/boton1JugarDesactivadoResized.png'
  );

  // Assets boton repetir
  scene.load.image(
    'botonRepetir',
    ROUTES.rutaRuletaBotones + '/boton2RepetirEstaticoResized.png'
  );
  scene.load.image(
    'botonRepetirHover',
    ROUTES.rutaRuletaBotones + '/boton2RepetirHoverResized.png'
  );
  scene.load.image(
    'botonRepetirPressed',
    ROUTES.rutaRuletaBotones + '/boton2RepetirPressedResized.png'
  );
  scene.load.image(
    'botonRepetirDesactivado',
    ROUTES.rutaRuletaBotones + '/boton2RepetirDesactivadoResized.png'
  );

  // Assets boton borrar
  scene.load.image(
    'botonBorrar',
    ROUTES.rutaRuletaBotones + '/boton3BorrarEstaticoResized.png'
  );
  scene.load.image(
    'botonBorrarHover',
    ROUTES.rutaRuletaBotones + '/boton3BorrarHoverResized.png'
  );
  scene.load.image(
    'botonBorrarPressed',
    ROUTES.rutaRuletaBotones + '/boton3BorrarPressedResized.png'
  );
  scene.load.image(
    'botonBorrarDesactivado',
    ROUTES.rutaRuletaBotones + '/boton3BorrarDesactivadoResized.png'
  );

  // Assets boton sumar
  scene.load.image(
    'botonSumarActivado',
    ROUTES.rutaRuletaBotones + '/boton4SumarActivadoResized.png'
  );
  scene.load.image(
    'botonSumarDesactivado',
    ROUTES.rutaRuletaBotones + '/boton4SumarDesactivadoResized.png'
  );
  scene.load.image(
    'botonSumarDesactivadoHover',
    ROUTES.rutaRuletaBotones + '/boton4SumarDesactivadoHoverResized.png'
  );
  scene.load.image(
    'botonSumarDesactivadoPressed',
    ROUTES.rutaRuletaBotones + '/boton4SumarDesactivadoPressedResized.png'
  );

  // Assets boton restar
  scene.load.image(
    'botonRestarActivado',
    ROUTES.rutaRuletaBotones + '/boton5RestarActivadoResized.png'
  );
  scene.load.image(
    'botonRestarDesactivado',
    ROUTES.rutaRuletaBotones + '/boton5RestarDesactivadoResized.png'
  );
  scene.load.image(
    'botonRestarDesactivadoHover',
    ROUTES.rutaRuletaBotones + '/boton5RestarDesactivadoHoverResized.png'
  );
  scene.load.image(
    'botonRestarDesactivadoPressed',
    ROUTES.rutaRuletaBotones + '/boton5RestarDesactivadoPressedResized.png'
  );
}
